import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import Alpine from 'alpinejs';

Alpine.directive('tooltip', (el, { expression, modifiers }, { evaluateLater, effect, cleanup }) => {
    const isHtml = modifiers.includes('html');
    const placement = modifiers.includes('right') ? 'right' : 'top';
    const getContent = evaluateLater(expression);

    const arrowBaseClass = 'absolute h-2 w-2 rotate-45 bg-gray-900';
    const arrowPlacementClass =
        placement === 'right'
            ? 'left-0 top-1/2 -ml-1 -translate-y-1/2'
            : 'left-1/2 top-full -mt-1 -translate-x-1/2';

    const tooltip = document.createElement('div');
    tooltip.className =
        'pointer-events-none fixed z-50 hidden whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs text-white shadow-lg';

    const arrow = document.createElement('div');
    arrow.className = `${arrowBaseClass} ${arrowPlacementClass}`;
    tooltip.appendChild(arrow);

    const content = document.createElement('span');
    content.className = 'relative';
    tooltip.appendChild(content);

    document.body.appendChild(tooltip);

    function position(): void {
        const triggerRect = el.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        if (placement === 'right') {
            tooltip.style.left = `${triggerRect.right + 8}px`;
            tooltip.style.top = `${triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2}px`;
        } else {
            tooltip.style.left = `${triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2}px`;
            tooltip.style.top = `${triggerRect.top - tooltipRect.height - 8}px`;
        }
    }

    function show(): void {
        tooltip.classList.remove('hidden');
        position();
    }

    function hide(): void {
        tooltip.classList.add('hidden');
    }

    el.addEventListener('mouseenter', show);
    el.addEventListener('mouseleave', hide);
    el.addEventListener('focus', show);
    el.addEventListener('blur', hide);

    cleanup(() => {
        tooltip.remove();
    });

    effect(() => {
        getContent((value) => {
            if (isHtml) {
                content.innerHTML = value as string;
            } else {
                content.textContent = value as string;
            }
        });
    });
});

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.start();
